import { useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { auth } from '@/lib/firebase.ts';
import { clearStoredCompanyId } from '@/features/dashboard/_root/access/currentCompany.ts';

const useSignOut = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const clearAppState = () => {
    clearStoredCompanyId();
    queryClient.clear();
  };

  const signOut = async () => {
    await auth.signOut().then(() => {
      navigate({ to: '/auth/login' });
      clearAppState();
    });
  };

  return { signOut, clearAppState };
};

export default useSignOut;
